import { createAction, createSlice } from "@reduxjs/toolkit";
import { Notification } from "../../@types/notification";
// Types
import findNotifications from "./actions/findNotifications";

interface NotificationsListState {
  notificationsList: Notification[];
  findStatus: string;
}

const initialState = {
  notificationsList: [],
  findStatus: "initial",
} as NotificationsListState;
export const addNotification = createAction<Notification>("ADD_NOTIFICATION");

const notificationsListSlice = createSlice({
  name: "notificationsList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addNotification, (state, { payload }) => {
        state.notificationsList.unshift(payload);
      })
      .addCase(findNotifications.pending, (state) => {
        state.findStatus = "pending";
      })
      .addCase(findNotifications.fulfilled, (state, { payload }) => {
        state.findStatus = "fulfilled";
        state.notificationsList = payload;
      })
      .addCase(findNotifications.rejected, (state) => {
        state.findStatus = "rejected";
        state.notificationsList = [];
      });
  },
});

export default notificationsListSlice.reducer;
